import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type {
  ExternalProviderRepository,
  SubmitRequestDataBody,
} from "@shared-kernel/application/ports/external-provider/external-provider-repository";

interface SubmitRequestDataCommand {
  requestId: string;
  body: SubmitRequestDataBody;
  externalProviderRepository: ExternalProviderRepository;
}

export const submitRequestData = createApiThunk<void, SubmitRequestDataCommand>(
  "externalProvider/submitRequestData",
  async ({ requestId, body, externalProviderRepository }) => {
    return externalProviderRepository.submitRequestData(requestId, body);
  },
);

export const resetSubmitRequestData = createAction("externalProvider/resetSubmitRequestData");
